import { render, staticRenderFns } from "./nbn-service-diagnostics.vue?vue&type=template&id=248f634a&scoped=true"
import script from "./nbn-service-diagnostics.vue?vue&type=script&lang=js"
export * from "./nbn-service-diagnostics.vue?vue&type=script&lang=js"
import style0 from "./nbn-service-diagnostics.vue?vue&type=style&index=0&id=248f634a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "248f634a",
  null
  
)

export default component.exports